"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6101],{

/***/ 56101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ FeatureScroll; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-sticky-box/dist/index.js
var dist = __webpack_require__(77134);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(97650);
;// CONCATENATED MODULE: ./public/assets/images/home/borderRight.webp
/* harmony default export */ var borderRight = ({"src":"/_next/static/media/borderRight.fc255060.webp","height":352,"width":94,"blurDataURL":"data:image/webp;base64,UklGRnQAAABXRUJQVlA4WAoAAAAQAAAAAQAABwAAQUxQSBEAAAAAnQD4E/9v/9L/2v92+RaeAABWUDggPAAAANABAJ0BKgIACAACQDgllAJ0AQ68BIEAAP7YaAS92mWzfmAfURsFBG+dZauYm9CftRgtDTSA3vRpw8MQAA==","blurWidth":2,"blurHeight":8});
// EXTERNAL MODULE: ./data/StaticList.ts + 69 modules
var StaticList = __webpack_require__(47027);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/home/4-features/FeatureScroll.tsx








function FeatureScroll() {
    const [selectedIndex, setSelectedIndex] = (0,react.useState)(0);
    // Create an array of useInView hooks for each feature
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const inViewRefs = StaticList/* FEATURE_LIST.map */.ql.map(()=>(0,react_intersection_observer_modern/* useInView */.YD)());
    (0,react.useEffect)(()=>{
        // Check which feature is in view
        inViewRefs.forEach((inViewRef, index)=>{
            if (inViewRef.inView) {
                setSelectedIndex(index);
            }
        });
    }, [
        inViewRefs
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        sx: {
            display: {
                xs: "none",
                md: "flex"
            },
            alignItems: "flex-start",
            maxWidth: "1440px",
            margin: "auto"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                style: {
                    padding: "85px 0px 50px 50px",
                    width: "60%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    width: "100%",
                    sx: {
                        padding: "50px 0px 50px 50px",
                        height: "100%"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        sx: {
                            display: {
                                xs: "none",
                                md: "flex"
                            },
                            flexDirection: "column"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                sx: {
                                    fontSize: {
                                        xs: "25px",
                                        md: "40px"
                                    }
                                },
                                style: {
                                    margin: "5px 0px 36px 0",
                                    letterSpacing: "-1px",
                                    wordSpacing: "-1px",
                                    fontWeight: "700"
                                },
                                children: "Unlock extra income for all your needs"
                            }),
                            StaticList/* FEATURE_LIST.map */.ql.map((item, i)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    id: selectedIndex === i ? "bgShade" : "bgShadeHover",
                                    ref: inViewRefs[i].ref,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: item.sideIcon,
                                            style: {
                                                color: "green",
                                                height: "24px",
                                                width: "24px",
                                                margin: "0px 10px"
                                            },
                                            alt: item.alt,
                                            loading: "lazy"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                            style: {
                                                margin: "0px 10px 0 0",
                                                padding: "0 10px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    sx: {
                                                        fontSize: "18px"
                                                    },
                                                    id: selectedIndex === i ? "featureTitleSelected" : "featureTitle",
                                                    children: item.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "body2",
                                                    fontWeight: 500,
                                                    id: selectedIndex === i ? "featureContSelected" : "featureCont",
                                                    children: item.content
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                    sx: {
                                                        height: "auto",
                                                        width: "94px",
                                                        position: "absolute",
                                                        top: 0,
                                                        bottom: 0,
                                                        right: 0,
                                                        backgroundColor: "white",
                                                        zIndex: 2,
                                                        display: selectedIndex === i ? "block" : "none"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: borderRight,
                                                        alt: "borderRIghtImg",
                                                        loading: "lazy",
                                                        width: 24,
                                                        height: 24
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }, i);
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    height: "fit-content"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    sx: {
                        margin: "auto"
                    },
                    children: StaticList/* FEATURE_LIST.map */.ql.map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            sx: {
                                height: {
                                    xs: "310px",
                                    md: "414px"
                                },
                                width: {
                                    xs: "310px",
                                    md: "414px"
                                },
                                display: {
                                    xs: "none",
                                    md: "flex"
                                },
                                borderRadius: "50%",
                                justifyContent: "center",
                                alignItems: "end",
                                fontSize: "28px",
                                objectFit: "cover",
                                margin: i === 3 ? "350px 0 0px 0" : "350px 0"
                            },
                            ref: inViewRefs[i].ref,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: item.staticIcon,
                                alt: item.alt,
                                loading: "lazy"
                            })
                        }, i))
                })
            })
        ]
    });
}


/***/ })

}]);